import { useQuery, UseQueryResult } from 'react-query'
import { fetchOilParams } from './services'
import { FetchOilParamsResults } from './types'

export default function useOilParamsQuery(): UseQueryResult<FetchOilParamsResults> {
   return useQuery('oilParams', fetchOilParams, { staleTime: 60 * (60 * 1000) })
}
